<template>
  <div class="content">
    <div class="title-box">
      <h3>{{allCommissionLan.title}}</h3>
    </div>
    <div class="panel">
      <div class="header">
        <div class="seek pull-left">
          <div class="pull-left">
            <button class="btn btn-default no-pointer acc" type="button">
              <span>{{allCommissionLan.account}}</span>
            </button>
          </div>
          <div class="pull-left form-group">
            <input type="text" class="form-control seekinput" v-model="seekStr" @keyup.enter="seekFn" :placeholder="allCommissionLan.seek">
          </div>
          <div class="pull-left btn btn-default btn-primary" @click="seekFn">{{allCommissionLan.seek}}</div>
          <div class="clear"></div>
        </div>
        <div class="pull-left btn-group">
          <jsonExcel v-if="jsonExcelAjax" class="btn btn-default" name="filename.xlsx" 
            :ajaxUrl="getIBInfoUrl || false" :ajaxPar="jsonExcelAjax.ajaxPar || false" 
            :ajaxType="jsonExcelAjax.ajaxType" :keys="thData" :ajaxGetKey="jsonExcelAjax.getKey" 
            :multiLanguage="allCommissionLan"
            :label = "label" :colData="[]">
              <i class="glyphicon glyphicon-save tab-he-glyphicon"></i>{{allCommissionLan.downloadExcelForms}}
          </jsonExcel>
        </div>
        <selPage v-if="selPage" class="pull-right" :multiLanguage="allCommissionLan" :selPage="selPage" @selPage="selPageFn"></selPage>
        <div class="clear"></div>
      </div>
      <div class="section">
        <!-- <h4>{{allCommissionLan.title}}</h4> -->
        <table class="table  table-striped DataTable">
          <thead>
            <tr>
              <th>{{allCommissionLan.type}}</th>
              <th>{{allCommissionLan.account}}</th>
              <th>{{allCommissionLan.name}}</th>
              <th>{{allCommissionLan.commissionReturn}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in trData">
              <td>{{allCommissionLan[item.type]}}</td>
              <td>{{item.ibId}}</td>
              <td>{{item.name}}</td>
              <td v-if="item.mode == 0">
                {{allCommissionLan.internalCommission+ ' : '}}
                <span v-for="(data,key) in item.first">
                    {{data}} {{allCommissionLan.unit}} 
                    <span v-if="key < item.first.length-1">/</span>
                </span>
              </td>
              <td v-else-if="item.mode == 1">
                {{allCommissionLan.CPACommission+ ' : '}}
                <span v-for="(data,key) in item.cpa">
                    {{data}} {{allCommissionLan.unit}} 
                    <span v-if="key < item.cpa.length-1">/</span>
                </span>
              </td>
              <td v-else-if="item.mode == 2">
                {{allCommissionLan.internalCommission+ ' : '}}
                <span v-for="(data,key) in item.first">
                    {{data}} {{allCommissionLan.unit}} 
                    <span v-if="key < item.first.length-1">/</span>
                </span>
                +
                {{allCommissionLan.CPACommission+ ' : '}}
                <span v-for="(data,key) in item.cpa">
                    {{data}} {{allCommissionLan.unit}} 
                    <span v-if="key < item.cpa.length-1">/</span>
                </span>
              </td>
              <td v-else>

              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="datatable-footer" v-if="selPage">
        <div class="dataTables_info" id="DataTables_Table_2_info" role="status" aria-live="polite">
            {{allCommissionLan.clauses}}{{allCommissionLan.amount}}:&nbsp;
            {{page.pageLeng}}&nbsp;&nbsp;{{allCommissionLan.present}}:&nbsp;{{page.active*selPage.limit-selPage.limit+1}}-{{Math.min(page.active*selPage.limit,page.pageLeng)}}
        </div>
        <div v-if="Math.ceil(page.pageLeng/selPage.list[selPage.active])>1" class="dataTables_paginate paging_simple_numbers" id="DataTables_Table_2_paginate">
            <pagination v-model="pageactive" 
              :boundary-links="true" :direction-links="true" 
              :total-page="Math.ceil(page.pageLeng/selPage.list[selPage.active])" 
              :max-size="5" @change="callpageFn">
            </pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Pagination } from "uiv"
import { mapMutations } from "vuex"
import jsonExcel from "components/commissionJsonExcel"
import selPage from "components/selPage"
import { Api } from 'api/commissionEnv'
import { URL_PREIBCON }  from 'api/commissionApi'
var api = new Api()

export default {
  components: {
    jsonExcel,
    selPage,
    Pagination
  },
  mixins: [
    require("common/mixin/base.js").base({allCommissionLan:"allCommissionReport"}),
  ],
  props: ['curArea'],
  data () {
    return {
      seekStr: '',
      trData: [],
      label: 'allCommissionReport',
      page: {  // 分页
        active: 1,  
        pageLeng: 0,
        offset: 0  // 查询数据库的offset需要的值，初始只为0组件内部处理最后给出一个能直接传给后台的值
      },
      selPage: {  // 配合分页的显示col数目选择
        list: [5, 10, 25, 50],  // 选择显示col数目
        active: localStorage.pageMaxIndex,  // 当前list的坐标
        limit: [5, 10, 25, 50][localStorage.pageMaxIndex]  // 查询数据库的limit需要的值，初始值设为list的0坐标组件内部处理最后给出一个传给后台的值 
      },
      //  pageactive: this.page ? this.page.active : "",
      pageactive: 1,
    }
  },
  computed: {
    thData () {
      return [
        this.allCommissionLan.type, this.allCommissionLan.account,
        this.allCommissionLan.name, this.allCommissionLan.commissionReturn,
      ]
    },
    getIBInfoUrl () {
      return api.getUrl20(this.curArea,URL_PREIBCON)
    },
    jsonExcelAjax () {
      return {
        url: api.getUrl20(this.curArea,URL_PREIBCON), 
        ajaxType: "get",
        getKey: ["data", "data", "rows"],
        ajaxPar: {
          pageNum: 0,
          pageSize: this.page.pageLeng,
          id: this.seekStr,
        }
      }
    }
  },
  methods:{
    pageInit () {
      this.$http.get(api.getUrl20(this.curArea,URL_PREIBCON),{params:{pageNum: this.pageactive-1,pageSize:this.selPage.limit, id:this.seekStr}}).then((res) => {
        if (res.data.code ==200 && res.data.data && res.data.msg == 'OK'){
          let data = res.data.data.data
          this.page.pageLeng = res.data.data.count
          this.trData = data
        }
      })
    },
    seekFn (){
      this.pageInit()
    },
    callpageFn (index) {
        this.page.active = index
        this.page.offset = this.selPage ? (this.page.active - 1) * this.selPage.list[this.selPage.active] : ""
        this.pageInit()
    },
    selPageFn (index, item) {
        this.SAVEPAGEMAXINDEX(index)
        this.selPage.active = index
        this.selPage.limit = this.selPage.list[this.selPage.active]
        this.page.offset = 0
        this.pageactive = 1
        this.page.active = 1
        this.pageInit()
    },
    ...mapMutations(["SAVEPAGEMAXINDEX"])
  },
  mounted () {
    this.pageInit()
  },
  watch: {
    curArea (val) {
      this.pageInit()
    }
  }
}
</script>


<style lang="scss" scoped>
.content{
  margin-top: 20px;
  .title-box{
    border: 1px solid #3F51B5;
    background: #3F51B5;
    padding: 0 20px;
    color: #fff;
    border-radius: 5px 5px 0 0;
  }
  .panel{
    .header{
      border-bottom: 1px solid #ddd;
      padding: 20px;
      .seek{
        display: inline-block;
        vertical-align: top;
        font-size: 0;
        .acc{
          border-radius: 3px 0 0 3px;
        }
        .seekinput{
          border-radius: 0;
          border-left: none;
        }
      }
      .btn-group{
        margin-left: 20px;
      }
    }
    .section{
      h4{
        padding: 0 20px;
        color: #3F51B5;
        font-weight: 550;
        font-size: 15px;
      }
      table{
        // border-top: 2px solid #3F51B5;
        thead tr{
          background-color: #EBEDF7;
        }
        th,td{
          border-left: 1px solid #ddd;
        }
        th:first-child,td:first-child{
          border-left: 0;
        }
      }
    }
  }
}
.mtable-tool-seek,.mtable-tool-selPage,.mtable-tool-fn {
    line-height: 36px;
  }
</style>



// WEBPACK FOOTER //
// allCommissionReport.vue?11bcc7a6